import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import VendorListUI from '../../components/finapp/vendor/VendorListUI'
import VendorAddModalSF from './../../components/finapp/vendor/VendorAddModalSF';
import VendorUpdateModalUI from './../../components/finapp/vendor/VendorUpdateModalUI';

const VendorListPageUI = ({ context, messageList, vendorList, filteredVendorList,
  // filters
  searchFilter, onSearchFilterChange,
  // form
  successMsg, errorList, setErrorList,
  // modes
  selectedCount, createMode, updateMode, deleteMode, submitted,
  // event handlers
  onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
  // event handlers in modals
  onSubmit, onConfirmUpdateClick, onCancelClick,
  // update form
  roleId, roleList, onRoleIdChange,
  //create vendor form
  // vendorName attributes and methods
  vendorName, onVendorNameChange, vendorNameError, setVendorNameError,
  // contact attributes and methods
  firstName, lastName, firstNameError, lastNameError, setFirstNameError, setLastNameError, onFirstNameChange, onLastNameChange,
  // phoneNumber attributes and methods
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  // email attributes and methods
  email, onEmailChange, emailError, setEmailError

}) =>
  <PrivatePageSF context={context} className='pg_acc_cust' backLink='/home'
    centered={!vendorList || vendorList.length === 0 || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_vendors'>
    {
      !vendorList && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      vendorList && vendorList.length === 0 && !(errorList && errorList.length) > 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateClick}
        createLinkKey='c_create_vendor'
        createDisabledMessageKey='c_no_vendor_msg'
      />
    }
    {
      vendorList && vendorList.length > 0 && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/home' messageList={messageList} titleMessageKey='c_vendors' />
        <VendorListUI
          context={context}
          vendorList={filteredVendorList}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }
    <VendorAddModalSF
      createMode={createMode}
      context={context}
      onCancelClick={onCancelClick}
      onSubmit={onSubmit}
      onRefreshClick={onRefreshClick}
    />

<VendorUpdateModalUI
      updateMode={updateMode}
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onCancelClick={onCancelClick}
      onConfirmUpdateClick={onConfirmUpdateClick}
      submitted={submitted}
      // vendorName attributes and methods
      vendorName={vendorName}
      onVendorNameChange={onVendorNameChange}
      vendorNameError={vendorNameError}
      setVendorNameError={setVendorNameError}
      // contact attributes and methods
      firstName={firstName}
      lastName={lastName}
      onFirstNameChange={onFirstNameChange}
      onLastNameChange={onLastNameChange}
      firstNameError={firstNameError}
      lastNameError={lastNameError}
      setFirstNameError={setFirstNameError}
      setLastNameError={setLastNameError}
      // phoneNumber attributes and methods
      phoneNumber={phoneNumber}
      onPhoneNumberChange={onPhoneNumberChange}
      phoneNumberError={phoneNumberError}
      setPhoneNumberError={setPhoneNumberError}
      // email attributes and methods
      email={email}
      onEmailChange={onEmailChange}
      emailError={emailError}
      setEmailError={setEmailError}
    />
  </PrivatePageSF>

export default VendorListPageUI
